import { Component, OnInit } from '@angular/core';
import { PageTitleService } from 'src/app/services/pagetitle.service';
import { UserPermissionsService } from './user-permissions.service';
import { SelectionService } from 'src/app/services/selection.service';
import { catchError, map, Observable, of, Subscription } from 'rxjs';
import { UserPermissionsActionComponent } from './modals/user-action/user-action.component';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SidenavComponent } from 'src/app/sidenav/sidenav.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ConfirmationComponent } from 'src/app/modals/confirmation/confirmation.component';
import { TranslateService } from '@ngx-translate/core';
import { SeoService } from '../seo/seo.service';
import { OrganicPaymentConfigComponent } from './modals/organic-payment-config/organic-payment-config.component';
import { TargetService } from '../sidenav/target.service';
import { NewTargetComponent } from '../metrics/user-management/modals/new-target/new-target.component';
import { SidenavService } from '../sidenav/sidenav.service';
import { CoreTargetService } from '../core/services/target.service';
import { LocalStorageService } from '../core/services/local-storage.service';
import { NotificationService } from '../core/services/notification.service';

@Component({
  selector: 'app-user-permissions',
  templateUrl: './user-permissions.component.html',
  styleUrls: ['./user-permissions.component.css'],
})
export class UserPermissionsComponent {
  constructor(
    private pageTitle: PageTitleService,
    private userService: UserPermissionsService,
    private selectorService: SelectionService,
    public dialog: MatDialog,
    private fb: FormBuilder,
    public sidenav: SidenavComponent,
    private translate: TranslateService,
    private seoService: SeoService,
    private targetService: TargetService,
    private sidenavService: SidenavService,
    private coreTargetService: CoreTargetService,
    private localStorageService: LocalStorageService,
    private notificationService: NotificationService,
  ) {}
  unallowedTarget = ['paid', 'tomtailorde'];
  unallowedTargetSelected: boolean = true;

  isBehamicsUser: boolean = false;

  userManagementSub: Subscription = new Subscription();

  newTargetDialog: MatDialogRef<NewTargetComponent>;
  confirmDialogRef: MatDialogRef<ConfirmationComponent>;
  userActionsDialog: MatDialogRef<UserPermissionsActionComponent>;
  paymentConfigDialog: MatDialogRef<OrganicPaymentConfigComponent>;

  selectedStore: any;
  selectedStoreDescription: any;
  firstLoader = false;
  refreshLoader = true;
  refreshLoaderTwo = true;
  chartLoader = true;
  loadNrIndicator = 0;

  oldData: any;
  oldDataTwo: any;
  formValueChanged = false;
  formValueChangedTwo = false;

  productRetrival: any = FormGroup;
  returnDataRetrieval: any = FormGroup;
  targetConfig: any = FormGroup;

  globalControlData: any;
  isSettingsValid = false;

  receivedUserList: any = [];
  recievedProductRetrivalData: any;
  isEmpty = false;
  receivedReturnProductData: any;
  currentUserEmail: any;

  goLiveObject: any = {
    target: '',
    target_db: '',
    selected_db: false,
    all_dbs: [],
    redis: 'redis-vm2',
    updating: false,
  };

  seoSubscription: any;

  showPremiumSeoBanner: boolean = false;

  chargesPerUser: any;

  stripeConfig: any;

  isStripeConfigUpdated: boolean = false;
  isWhiteLabel: boolean = false;
  isMaster: boolean = false;

  isTargetLoading: boolean = false;

  ngOnInit() {
    this.isWhiteLabel = this.localStorageService.get('isWhiteLabel') || false;
    this.isMaster =
      this.localStorageService.get('role') == 'master' ? true : false;

    this.pageTitle.setTitle('User_Management');

    this.userManagementSub.add(
      this.sidenavService.getIsTargetLoading().subscribe((loading: boolean) => {
        this.isTargetLoading = loading;
      }),
    );

    const email: string | null = this.localStorageService.get('email');
    this.isBehamicsUser = email?.endsWith('@behamics.com') || false;

    // On Target Change
    const selectorService = this.selectorService.currentMessage.subscribe(
      (message: any) => {
        this.selectedStoreDescription =
          this.coreTargetService.getSelectedTarget('name');
        this.selectedStore = this.coreTargetService.getSelectedTarget('target');

        this.unallowedTargetSelected = this.unallowedTarget.includes(
          this.selectedStore,
        );

        const email: string | null = this.localStorageService.get('email');

        this.isBehamicsUser = email?.endsWith('@behamics.com') || false;

        this.seoSubscription = this.localStorageService.get('seoSubscription');

        this.goLiveObject.target =
          this.coreTargetService.getSelectedTarget('target');
        this.loadNrIndicator = 0;

        this.showPremiumSeoBanner =
          this.seoSubscription == 'Premium' ? false : true;
        this.getUserList();
        // this.getConfigData();
        // this.getTargetSettings();

        // this.getTargetConnections();

        this.userManagementSub.add(
          this.targetService
            .getCurrentUserRoles(this.localStorageService.get('email'))
            .subscribe({
              next: (res) => {
                this.isStripeConfigUpdated = true;
                this.stripeConfig = res.stripeConfig || null;
              },
              error: (err) => {
                this.isStripeConfigUpdated = true;
                console.log(err);
              },
            }),
        );

        if (
          this.localStorageService.get('customerId') &&
          this.localStorageService.get('customerId') != 'null' &&
          this.localStorageService.get('customerId') != 'undefined'
        ) {
          this.getStripeCustomer();
        }

        if (sessionStorage.getItem('edit-config') && this.isBehamicsUser) {
          this.addPaymentConfigDialog();
        }
        sessionStorage.removeItem('edit-config');
      },
    );
    this.userManagementSub.add(selectorService);
    this.selectedStore = this.coreTargetService.getSelectedTarget('target');
  }

  ngOnDestroy() {
    this.userManagementSub?.unsubscribe();
  }

  getStripeCustomer() {
    this.userManagementSub.add(
      this.seoService
        .getStripeCustomer({
          customerId: this.localStorageService.get('customerId'),
          target: this.selectedStore,
        })
        .subscribe({
          next: (res: any) => {
            this.chargesPerUser = this.formatCurrency(
              res?.subscription?.unitAmount,
              res?.subscription?.currency,
            );
          },
          error: (err: any) => {
            console.log(err);
          },
        }),
    );
  }

  getTargetConnections() {
    try {
      const goLiveAPI = this.userService
        .getGoLiveObject({
          target: this.goLiveObject.target,
        })
        .subscribe({
          next: (res) => {
            this.goLiveObject.target_db = res.target_db;
            this.goLiveObject.selected_db =
              res.target_db == 'No Database' ? false : true;
            this.goLiveObject.all_dbs = res.all_dbs || [];
          },
        });
      this.userManagementSub.add(goLiveAPI);
    } catch (e) {
      console.log(e);
    }
  }

  checkSelfEmail(user: any) {
    let currentEmail = this.localStorageService.get('email');

    if (currentEmail == user.email) {
      return false;
    } else {
      return true;
    }
  }

  setGoLiveProcess() {
    if (
      this.goLiveObject.target_db == 'No Database' ||
      this.goLiveObject.selected_db
    ) {
      return;
    }
    let obj = {
      target: this.goLiveObject.target,
      redis: this.goLiveObject.redis,
      db: this.goLiveObject.target_db,
    };

    this.goLiveObject.updating = true;
    try {
      const goLiveProcess = this.userService.setGoLiveProcess(obj).subscribe({
        next: (res) => {
          this.goLiveObject.updating = false;

          this.getTranslatedText(
            'go_live_process_finished',
            'phrases',
          ).subscribe((translatedText) => {
            this.notificationService.info(translatedText);
          });
          this.getTargetConnections();
        },
        error: (e) => {
          this.goLiveObject.updating = false;
          this.getTranslatedText('something_went_wrong', 'phrases').subscribe(
            (translatedText) => {
              this.notificationService.error(translatedText);
            },
          );
          console.log(e);
        },
      });
      this.userManagementSub.add(goLiveProcess);
    } catch (e) {
      console.log(e);
    }
  }

  formatOrganicRole(role: string) {
    switch (role) {
      case 'seo_manager':
        return 'Manager';
      case 'seo_content_writer':
        return 'Content Writer';
      case 'seo_backlink_provider':
        return 'Backlink Provider';
      case 'marketing_officer':
        return 'Marketing Officer';
      default:
        return '-';
    }
  }

  getUserList() {
    // Get User Data
    this.refreshLoader = true;
    const getUserList = this.userService
      .getUsers(this.selectedStore)
      .subscribe((info: any) => {
        this.refreshLoader = false;
        this.receivedUserList = info;
        this.receivedUserList.forEach((user: any) => {
          if (user.lastVisited) {
            user.lastVisited_formatted = new Date(
              user?.lastVisited,
            ).toLocaleString('en-US', {
              hour: 'numeric',
              minute: 'numeric',
              hour12: false,
              day: 'numeric',
              month: 'short',
            });
          }

          user.formatted_organic_role = this.formatOrganicRole(user?.SEO_role);
        });
        this.combinedLoader(1);
      });
    this.userManagementSub.add(getUserList);
  }

  getConfigData() {
    const getProductRetrivalConfig = this.userService
      .getProductRetrivalConfig()
      .subscribe((info: any) => {
        this.recievedProductRetrivalData = info.filter(
          (o: any) => o.target == this.selectedStore,
        );
        this.updateRetrievalData();
      });
    this.userManagementSub.add(getProductRetrivalConfig);

    const returnDataRetrivalConfig = this.userService
      .returnDataRetrivalConfig()
      .subscribe((info: any) => {
        this.receivedReturnProductData = info.filter(
          (o: any) => o.target == this.selectedStore,
        );
        this.updateReturnRetrievalData();
      });
    this.userManagementSub.add(returnDataRetrivalConfig);
  }

  getTargetSettings() {
    const getSettings = this.userService
      .getSettings(this.selectedStore)
      .subscribe((info: any) => {
        this.globalControlData = info[0];
        this.updateTargetSettings();
      });
    this.userManagementSub.add(getSettings);
  }

  updateTargetSettings() {
    this.targetConfig = this.fb.group({
      globalControl: ['', Validators.required],
      isLive: ['', Validators.required],
      currency: ['', Validators.required],
    });
    this.targetConfig.patchValue({
      globalControl: this.globalControlData.value,
      isLive: this.globalControlData.live,
      currency: this.globalControlData.currency,
    });

    var oldData = this.globalControlData;

    const valueChanges = this.targetConfig.valueChanges.subscribe(
      (data: any) => {
        if (
          JSON.stringify(oldData) === JSON.stringify(this.targetConfig.value)
        ) {
          this.isSettingsValid = false;
        } else {
          this.isSettingsValid = true;
        }
      },
    );
    this.userManagementSub.add(valueChanges);
  }

  editSettings() {
    var oldData = this.globalControlData;
    var newData = {
      description: this.globalControlData.description,
      live: this.targetConfig.value.isLive,
      name: this.globalControlData.name,
      value: this.targetConfig.value.globalControl,
      currency: this.targetConfig.value.currency,
    };
    const updateSettings = this.userService
      .updateSettings(newData, oldData, this.selectedStore)
      .subscribe((info) => {
        this.getTranslatedText('settings_updated', 'words').subscribe(
          (translatedText) => {
            this.notificationService.info(translatedText);
          },
        );
      });
    this.userManagementSub.add(updateSettings);
  }

  updateRetrievalData() {
    try {
      this.productRetrival = this.fb.group({
        execAt: ['', Validators.required],
        executeEveryHour: ['', Validators.required],
        target: ['', Validators.required],
        type: ['', Validators.required],
        url: ['', Validators.required],
        dataType: ['', Validators.required],
        authType: [''],
        username: [''],
        password: [''],
        online: ['', Validators.required],
      });

      if (this.recievedProductRetrivalData.length != 0) {
        this.isEmpty = false;
        this.productRetrival.patchValue({
          execAt: this.recievedProductRetrivalData[0].execAt,
          executeEveryHour:
            this.recievedProductRetrivalData[0].executeEveryHour,
          target: this.recievedProductRetrivalData[0].target,
          type: this.recievedProductRetrivalData[0].type,
          url: this.recievedProductRetrivalData[0].url,
          dataType: this.recievedProductRetrivalData[0].dataType,
          authType: this.recievedProductRetrivalData[0].authType,
          username: this.recievedProductRetrivalData[0].username,
          password: this.recievedProductRetrivalData[0].password,
          online: this.recievedProductRetrivalData[0].online,
        });
        this.oldData = this.productRetrival.value;

        const productRetrivalValue =
          this.productRetrival.valueChanges.subscribe((data: any) => {
            if (
              JSON.stringify(this.oldData) ===
              JSON.stringify(this.productRetrival.value)
            ) {
              this.formValueChanged = false;
            } else {
              this.formValueChanged = true;
            }
          });
        this.userManagementSub.add(productRetrivalValue);
      } else {
        this.isEmpty = true;
      }
      this.combinedLoader(1);
    } catch (e) {
      console.log('updateRetrievalData', e);
    }
  }

  updateReturnRetrievalData() {
    try {
      this.returnDataRetrieval = this.fb.group({
        target: [{ value: '', disabled: true }, Validators.required],
        online: ['', Validators.required],
        type: ['', Validators.required],
        timeToCallStart: ['', Validators.required],
        timeToCallEnd: ['', Validators.required],

        accountName: ['', Validators.required],
        accountKey: ['', Validators.required],
        container: ['', Validators.required],

        orderFileFormat: ['', Validators.required],
        returnFileFormat: ['', Validators.required],
        dateFormat: ['', Validators.required],
        encoding: ['', Validators.required],
        seperator: ['', Validators.required],
      });
      if (this.receivedReturnProductData[0]) {
        this.returnDataRetrieval.patchValue({
          target: this.receivedReturnProductData[0].target,
          online: this.receivedReturnProductData[0].online,
          type: this.receivedReturnProductData[0].type,
          timeToCallStart: this.receivedReturnProductData[0].timeToCall[0],
          timeToCallEnd: this.receivedReturnProductData[0].timeToCall[1],

          accountName:
            this.receivedReturnProductData[0].fileConfig.azure.accountName,
          accountKey:
            this.receivedReturnProductData[0].fileConfig.azure.accountKey,
          container:
            this.receivedReturnProductData[0].fileConfig.azure.container,

          orderFileFormat:
            this.receivedReturnProductData[0].fileConfig.orderFileFormat,
          returnFileFormat:
            this.receivedReturnProductData[0].fileConfig.returnFileFormat,
          dateFormat: this.receivedReturnProductData[0].fileConfig.dateFormat,
          encoding: this.receivedReturnProductData[0].fileConfig.encoding,
          seperator: this.receivedReturnProductData[0].fileConfig.seperator,
        });
      }
      this.oldDataTwo = this.returnDataRetrieval.value;
      const returnDataRetrievalValue =
        this.returnDataRetrieval.valueChanges.subscribe((data: any) => {
          if (
            JSON.stringify(this.oldDataTwo) ===
            JSON.stringify(this.returnDataRetrieval.value)
          ) {
            this.formValueChangedTwo = false;
          } else {
            this.formValueChangedTwo = true;
          }
        });
      this.userManagementSub.add(returnDataRetrievalValue);
      this.combinedLoader(1);
    } catch (e) {
      console.log('updateReturnRetrievalData Error: ', e);
    }
  }

  editRetrievalConfig() {
    const editProductRetrivalConfig = this.userService
      .editProductRetrivalConfig({
        execAt: this.productRetrival.value.execAt,
        executeEveryHour: this.productRetrival.value.executeEveryHour,
        target: this.productRetrival.value.target,
        type: this.productRetrival.value.type,
        url: this.productRetrival.value.url,
        dataType: this.productRetrival.value.dataType,
        authType: this.productRetrival.value.authType,
        username: this.productRetrival.value.username,
        password: this.productRetrival.value.password,
        online: this.productRetrival.value.online,
      })
      .subscribe((info) => {
        this.loadNrIndicator = 1;
        this.refreshLoaderTwo = false;
        this.getConfigData();

        this.getTranslatedText(
          'product_Retrieval_Config_Updated',
          'phrases',
        ).subscribe((translatedText) => {
          this.notificationService.info(translatedText);
        });
      });
    this.userManagementSub.add(editProductRetrivalConfig);
  }

  editReturnDataConfig() {
    const editReturnRetrivalConfig = this.userService
      .editReturnRetrivalConfig({
        target: this.returnDataRetrieval.value.target,
        online: this.returnDataRetrieval.value.online,
        type: this.returnDataRetrieval.value.type,
        timeToCall: [
          this.returnDataRetrieval.value.timeToCallStart,
          this.returnDataRetrieval.value.timeToCallEnd,
        ],
        fileConfig: {
          azure: {
            accountName: this.returnDataRetrieval.value.accountName,
            accountKey: this.returnDataRetrieval.value.accountKey,
            container: this.returnDataRetrieval.value.container,
          },
          orderFileFormat: this.returnDataRetrieval.value.orderFileFormat,
          returnFileFormat: this.returnDataRetrieval.value.returnFileFormat,
          dateFormat: this.returnDataRetrieval.value.dateFormat,
          encoding: this.returnDataRetrieval.value.encoding,
          seperator: this.returnDataRetrieval.value.seperator,
        },
      })
      .subscribe((info) => {
        this.loadNrIndicator = 1;
        this.refreshLoaderTwo = false;
        this.getConfigData();
        this.getTranslatedText(
          'return_Data_Retrieval_Config_Updated',
          'phrases',
        ).subscribe((translatedText) => {
          this.notificationService.info(translatedText);
        });
      });
    this.userManagementSub.add(editReturnRetrivalConfig);
  }

  // openRolesDialog() {
  //   this.addRolesDialog = this.dialog.open(AddRolesComponent, {
  //     width: '460px',
  //     data: {},
  //     autoFocus: false,
  //   });
  // }

  addUserDialog(isEdit: boolean, data: any) {
    let isPremiumSubscription = false;
    if (data?.seoSubscription?.[0]?.seoSubscription === 'Premium') {
      isPremiumSubscription = true;
    }

    if (isEdit) {
      this.userActionsDialog = this.dialog.open(
        UserPermissionsActionComponent,
        {
          width: '650px',
          data: {
            name: data.name,
            email: data.email,
            role: data.role,
            target: data.shopID,
            bugSubscription: data.bugSubscription,
            authProvider: data.authProvider ? data.authProvider : 'local',
            isPremiumSubscription: isPremiumSubscription,
            stripeConfig: this.stripeConfig,
          },
          autoFocus: false,
        },
      );

      const userActionsDialogE = this.userActionsDialog
        .afterClosed()
        .subscribe((result) => {
          if (result == 'updated') {
            // Reload List
            this.loadNrIndicator = 1;
            this.refreshLoader = false;
            this.getUserList();

            this.getTranslatedText('user_updated', 'words').subscribe(
              (translatedText) => {
                this.notificationService.info(translatedText);
              },
            );
          }
        });
      this.userManagementSub.add(userActionsDialogE);
    } else {
      // New User
      this.userActionsDialog = this.dialog.open(
        UserPermissionsActionComponent,
        {
          width: '430px',
          data: {
            target: this.selectedStore,
            chargesPerUser: this.chargesPerUser,
            stripeConfig: this.stripeConfig,
          },
          autoFocus: false,
        },
      );

      const userActionsDialogI = this.userActionsDialog
        .afterClosed()
        .subscribe((result) => {
          if (result == 'invited') {
            // Reload List
            this.loadNrIndicator = 1;
            this.refreshLoader = false;
            this.getUserList();

            this.getTranslatedText(
              'user_has_been_invited',
              'phrases',
            ).subscribe((translatedText) => {
              this.notificationService.info(translatedText);
            });
          } else if (result == 'added') {
            // Reload List
            this.loadNrIndicator = 1;
            this.refreshLoader = false;
            this.getUserList();
            this.getTranslatedText(
              'user_has_been_created',
              'phrases',
            ).subscribe((translatedText) => {
              this.notificationService.info(translatedText);
            });
          }
        });
      this.userManagementSub.add(userActionsDialogI);
    }
  }
  updateStripeConfig() {
    this.isStripeConfigUpdated = false;
    this.userManagementSub.add(
      this.targetService
        .getCurrentUserRoles(this.localStorageService.get('email'))
        .subscribe({
          next: (res) => {
            this.stripeConfig = res.stripeConfig || null;
            this.isStripeConfigUpdated = true;
          },
          error: (err) => {
            this.isStripeConfigUpdated = true;
            console.log(err);
          },
        }),
    );
  }
  addPaymentConfigDialog() {
    if (!this.isStripeConfigUpdated) {
      setTimeout(() => {
        this.addPaymentConfigDialog();
      }, 100);
      return;
    }

    this.paymentConfigDialog = this.dialog.open(OrganicPaymentConfigComponent, {
      width: '430px',
      autoFocus: false,
      ...(this.stripeConfig ? { data: this.stripeConfig } : {}),
    });

    this.userManagementSub.add(
      this.paymentConfigDialog.afterClosed().subscribe((result) => {
        if (result == 'added' || result == 'updated') {
          this.updateStripeConfig();
          this.notificationService.info(`Payment config ${result}!`);
        }
      }),
    );
  }
  getTranslatedText(text: string, type: string = 'words'): Observable<string> {
    return this.translate.get(`${type}.${text}`).pipe(
      map((translated: string) =>
        translated === `${type}.${text}` ? text : translated,
      ),
      catchError(() => of(text)),
    );
  }
  resendUserEmail(email: any, index: any) {
    this.confirmDialogRef = this.dialog.open(ConfirmationComponent, {
      width: '430px',
      data: {
        header: 'Resend Email',
        content: 'Are you sure you want to resend the invitation?',
      },
    });

    const confirmDialogRef = this.confirmDialogRef
      .afterClosed()
      .subscribe((result) => {
        if (result == 1) {
          this.userService.resendEmail(email.email).subscribe((info) => {
            this.loadNrIndicator = 1;
            this.refreshLoader = false;
            this.getConfigData();

            this.getTranslatedText('invitation_resent', 'phrases').subscribe(
              (translatedText) => {
                this.notificationService.info(translatedText);
              },
            );
          });
        }
      });
    this.userManagementSub.add(confirmDialogRef);
  }

  deleteUserDialog(user: any) {
    this.confirmDialogRef = this.dialog.open(ConfirmationComponent, {
      width: '430px',
      data: {
        header: 'delete_user',
        content: 'are_you_sure_you_want_to_delete_this_user',
      },
    });

    const confirmDialogRef = this.confirmDialogRef
      .afterClosed()
      .subscribe((result) => {
        if (result == 1) {
          this.userService
            .deleteUser({
              email: user.email,
              shopID: this.selectedStore,
              ...(this.localStorageService.get('customerId')
                ? { customerId: this.localStorageService.get('customerId') }
                : {}),
            })
            .subscribe((info) => {
              this.getTranslatedText(
                'user_deleted_successfully',
                'phrases',
              ).subscribe((translatedText) => {
                this.notificationService.info(translatedText);
              });
              this.loadNrIndicator = 1;
              this.refreshLoader = false;
              this.getUserList();
            });
        }
      });
    this.userManagementSub.add(confirmDialogRef);
  }

  combinedLoader(num: any) {
    this.loadNrIndicator = this.loadNrIndicator + num;
    if (this.loadNrIndicator == 1) {
      setTimeout(() => {
        this.firstLoader = true;
        this.refreshLoader = false;
        this.refreshLoaderTwo = true;
      }, 400);
    }
  }

  formatCurrency(value: any, currency: any) {
    if (currency === 'AUD') {
      return (
        'A' +
        new Intl.NumberFormat('en-AU', {
          style: 'currency',
          currency: currency,
        })
          .format(value)
          ?.replace('.00', '')
      );
    }
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: currency,
    })
      .format(value)
      .replace('.00', '');
  }
  addNewUser() {
    if (!this.isBehamicsUser && !this.isWhiteLabel) return;

    this.newTargetDialog = this.dialog.open(NewTargetComponent, {
      width: '430px',
      autoFocus: false,
      data: {
        role: 'sub-master',
        targetShop: this.isWhiteLabel ? 'paid' : 'behamicsWeb',
        timezone: this.isWhiteLabel ? 'America/New_York' : 'Europe/Berlin',
        region: this.isWhiteLabel ? 'central-us' : 'west-eu',
        country: this.isWhiteLabel ? 'United States' : 'Germany',
        prefillAndHide: {
          role: true,
          targetShop: true,
        },
      },
    });

    const newTargetDialog = this.newTargetDialog
      .afterClosed()
      .subscribe((result) => {
        if (result == 'created') {
          this.loadNrIndicator = 0;
          this.refreshLoader = false;
          this.getConfigData();
          this.getUserList();
          this.sidenav.refreshTargetList();
          this.notificationService.info('New Client Created!');
        }
      });
    this.userManagementSub.add(newTargetDialog);
  }

  deleteTarget() {
    this.confirmDialogRef = this.dialog.open(ConfirmationComponent, {
      width: '430px',
      data: {
        header: 'Delete Target',
        content: `Are you sure you want to delete this target?`,
        target: this.selectedStore,
        confirmationInput: true,
        confirmationInputValue: this.selectedStore,
        confirmButtonDangerStyle: true,
        cancel_btn: 'Cancel',
        confirm_btn: 'Yes, delete target',
      },
    });

    const confirmDialogRef = this.confirmDialogRef
      .afterClosed()
      .subscribe((result) => {
        if (result == 1) {
          if (this.unallowedTarget.includes(this.selectedStore)) {
            this.notificationService.warn(
              'You are not allowed to delete this target!',
            );
            return;
          }
          this.sidenavService.setIsTargetLoading(true);
          this.userService
            .deleteTarget(this.selectedStore)
            .subscribe((info) => {
              sessionStorage.removeItem('selectedTargetTmp');
              this.notificationService.info('Target Deleted!');
              this.sidenav.refreshTargetList(true);
            });
        }
      });
    this.userManagementSub.add(confirmDialogRef);
  }
}
